import { render } from "./standardFooter.vue?vue&type=template&id=448d779e&scoped=true"
import script from "./standardFooter.vue?vue&type=script&lang=js"
export * from "./standardFooter.vue?vue&type=script&lang=js"

import "./standardFooter.vue?vue&type=style&index=0&id=448d779e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448d779e"]])

export default __exports__